import { Button, Form, Input, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import {
  getMeToTreiningAquatic,
  getPhasesAquatic,
} from "services/aquatic/aquatic-service";
import { FONT, USER_STORAGE } from "constants/index";

import { notificationErroInternal, notificationInfo, notificationSucessMsg } from "util/api-utils";
import { resetPassword } from "services/login/login-service";

import DetailAquatic from "./managerial-detail-aqua";
import DetailAquaUser from "./managerial-detail-aqua-user";
import DetailAquaMock from "./managerial-detail-aqua-user";
import { getById } from "services/user/user-service";

const ManagerialAquaUser = () => {
  const [loading, setLoading] = useState(true);
  const [phases, setPhases] = useState([{ subphases: [] }]);
  const [userTrainer, setUserTrainer] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [formRefNewPassword] = Form.useForm();

  useEffect(() => {
    refreshData();
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { id } = JSON.parse(localStorageItem);
      getById(id).then((res) => {
        setIsModalOpen(res.shouldResetPassword);
      });
    }
  }, [localStorage.getItem(USER_STORAGE)]);

  const refreshData = () => {
    getAll();
  };
  async function getAll() {
    try {
      setLoading(true);
      await Promise.all([getPhases(), getMeTraining()]);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  }
  const getPhases = async () => {
    try {
      const data = await getPhasesAquatic();
      setPhases(data);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  };
  const getMeTraining = async () => {
    try {
      const data = await getMeToTreiningAquatic();
      setUserTrainer(data);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  };

  const findSubphaseById = (subphaseId) => {
    for (const phase of phases) {
      const found = phase.subphases.find((sub) => sub.id === subphaseId);
      if (found) {
        return { phase, subphase: found };
      }
    }
    return null;
  };

  const calcPercent = (tasksDone = [], objectives = []) => {
    const objectiveTaskIds = new Set(
      objectives.flatMap((obj) => obj.tasks?.map((task) => task.id) || [])
    );

    const filteredDone = tasksDone.filter((done) =>
      objectiveTaskIds.has(done.taskId)
    );

    const totalTasks = objectiveTaskIds.size;
    const doneCount = filteredDone.length;

    if (totalTasks === 0) return 0;

    const percent = (doneCount / totalTasks) * 100;

    return Math.round(percent);
  };

  const handleCancel = () => {
    formRefNewPassword.resetFields();
    setIsModalOpen(false);
    setIsLoadingPassword(false);
  };
  const handleOk = () => {
    setIsLoadingPassword(true);
    formRefNewPassword
      .validateFields()
      .then((values) => {
        if (values.password != values.confirmPassword) {
          notificationInfo("As senhas devem ser iguais!");
          setIsLoadingPassword(false);
          return;
        }

        const request = {
          id: userTrainer.id,
          password: values.password,
        };
        resetPassword(request)
          .then(() => {
            notificationSucessMsg("Senha alterada com sucesso!");
            handleCancel();
          })
          .catch((err) => {
            setIsLoadingPassword(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde"
            );
          });
      })
      .catch((errors) => {
        setIsLoadingPassword(false);
        console.log(errors);
      });
  };

  return (
    <>
      <Spin spinning={loading}>
        <DetailAquaUser
          user={userTrainer}
          findSubphaseById={findSubphaseById}
          calcPercent={calcPercent}
          allPhases={phases}
        />
      </Spin>
      <Modal
        className="modal-password"
        style={{ textAlign: "center" }}
        title="Definir Nova Senha"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoadingPassword}
            onClick={handleOk}
          >
            Salvar
          </Button>,
        ]}
      >
        <Form
          form={formRefNewPassword}
          layout={"vertical"}
          style={{ maxWidth: 600, fontFamily: FONT }}
        >
          <Form.Item
            label="Senha"
            name="password"
            rules={[
              {
                required: true,
                message: "È necessário informar a senha",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirmar Senha"
            name="confirmPassword"
            rules={[
              {
                required: true,
                message: "È necessário informar a confirmação de senha",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ManagerialAquaUser;
